<template>
    <div>
        <!-- 轮播图 -->
        <div class="header">
            <div class="header-tag">News</div>
            <div class="header-title">新闻动态</div>
        </div>
        <div style="margin: 30px 0;">
            <ul class="news-container">
                <li v-for="(item,index) in newsList" :key="index" >
                    <div class="content">
                        <p @click="goPage(item.ettribute1)">{{item.title}}</p>
                        <!-- <p @click="goPage(item.redurl)">{{item.title}}</p> -->
                        <!-- <p>{{item.introduce}}</p> -->
                        <!-- <p @click="page(item.id)">{{item.title}}</p> -->
                    </div>
                    <div class="time">
                        <!-- <p>{{item.occuDate}}</p> -->
                        <!-- <span>{{item.year}}</span> -->
                        <span>{{item.occuDate}}</span>
                    </div>
                    <div class="circle">
                        <img src="../../assets/img/circle.png">
                         <i class="line center-block"></i> 
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
  
<script type="text/babel">
export default {
  name: "HomePage",
  data() {
    return {
        goPage(url){
                            if(url!=''&&url!=null){
                                window.location.href = url
                            }
                            
                        },
        newsList:[

                        ]
      
        // newsList:[
        //         {
        //             id: '001',
        //             title: '中国工业车辆电动控制核心技术实现自主可控-行业知名媒体中叉网专访凡己科技',
        //             // introduce: '凡己科技（苏州）有限公司的“FJ-D1高效交流控制器及M1智能仪表组件”荣获零部件类金奖。', 
        //             date: '07-08',
        //             year: '2022.07',
        //             redurl:'https://mp.weixin.qq.com/s/gcL2HyQGARk-lNaa4SnRvw'
        //         },{
        //             id: '002',
        //             title: '凡己科技主起草的国内首个非道路电动车辆控制器标准由中国工程机械工业协会批准发布',
        //             // introduce: '据悉，在搭载了凡己电控的众多电动叉车中，不乏有远销海外并在极端恶劣工况下工作，客户反响极好，通过其他国家地区客户的认可与验证，这也再次证明了中国制造的实力。 ',
        //             date: '06-10',
        //             year: '2022.06',
        //             redurl:'https://mp.weixin.qq.com/s/6Lxc41T5nOOWR32jBJQOFA'
        //         },{
        //             id: '003',
        //             title: '同盟聚力，合作共赢-凡己科技供应商战略研讨会暨十周年晚宴圆满举办',
        //             // introduce: '苏商联合产业投资基金与凡己科技就深入开展电驱动领域合作达成战略协议，双方对绿色驱动的前景共同看好，约定在凡己科技进一步发展的产业布局、资源投入、规范化治理等诸多事项上共同努力。',
        //             date: '01-22',
        //             year: '2022.01',
        //             redurl:'https://mp.weixin.qq.com/s/PKilJfR65i8pzp78AOyUQQ'
        //         },{
        //             id: '004',
        //             title: '九年拼搏结硕果 今朝盛装迎贵宾 -中国工业车辆行业领导莅临凡己科技（苏州)有限公司',
        //             // introduce: '经过杭叉集团和用户的双重验证，凡己电控的可靠性得到了极大的肯定。国产电控和进口电控的差剧正以肉眼可见的速度缩小，甚至两者在各项性能上的优劣已经趋于模糊。',
        //             date: '09-24',
        //             year: '2020.09',
        //             redurl:'https://mp.weixin.qq.com/s/63HyfjeBUFTksg7XdAkz2Q'
        //         },{
        //             id: '005',
        //             title: '专业铸造品牌 高品质助力观光车行业发展 -凡己科技在观光车行业年会上交流分享',
        //             // introduce: '凡己科技通过三年时间的发展与技术进步，成为了国内有成熟技术的国产电控生产企业，已与国内多家知名叉车厂商建立了合作关系，并不断在扩大产业范围。',
        //             date: '10-13',
        //             year: '2019.10',
        //             redurl:'https://mp.weixin.qq.com/s/oAQJj4PFZi8WlN5yJhe_VA'
        //         },{
        //             id: '006',
        //             title: '凡己科技交流控制器及智能仪表获“中国工业车辆创新奖”金奖',
        //             // introduce: '经过六年创新创业，公司进入了新的发展阶段，凡己电控在工业车辆行业全面推广，公司新产品在新的行业领域应用取得进展。',
        //             date: '09-09',
        //             year: '2019.09',
        //             redurl:'https://mp.weixin.qq.com/s/jFhF8M6ykIayUmawWIcdrA'
        //         },{
        //             id: '007',
        //             title: '什么，烈日炎炎，叉车会“中暑”吗？',
        //             // introduce: '凡己科技作为唯一电控厂家受邀列席并与大家分享了凡己科技电控产品的特点和优势。',
        //             date: '07-31',
        //             year: '2019.07',
        //             redurl:'https://mp.weixin.qq.com/s/FGWDxaFbykS7WXZVfAM3_w'
        //         },{
        //             id: '008',
        //             title: '为什么我们公司坚决不做半交流电控',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '05-15',
        //             year: '2019.05',
        //             redurl:'https://mp.weixin.qq.com/s/fJTQU2ZWPzoJ4zxdWek_xA'
        //         },{
        //             id: '009',
        //             title: '用户满意——凡己科技客户回访系列报道之宝骊篇',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '03-18',
        //             year: '2019.03',
        //             redurl:'https://mp.weixin.qq.com/s/xGGLySw1R7vEL0bfcxtnnw'
        //         },{
        //             id: '010',
        //             title: '你身边的电控服务商——凡己科技“服务年”全面开启',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '02-15',
        //             year: '2019.02',
        //             redurl:'https://mp.weixin.qq.com/s/qU1P5v9yYtV8XZNyj75Qdg'
        //         },{
        //             id: '011',
        //             title: '凡己电控无惧冷库考验 ——凡己科技客户回访系列报道之龙工篇',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-27',
        //             year: '2019.01',
        //             redurl:'https://mp.weixin.qq.com/s/p9SMoCkdxViuRySkuBLt-A'
        //         },{
        //             id: '012',
        //             title: '自主核心技术助力民族产业——凡己科技客户回访系列报道之合力篇',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-12',
        //             year: '2019.01',
        //             redurl:'https://mp.weixin.qq.com/s/yV4sEfCkX4l1L_djAiPBWA'
        //         },{
        //             id: '013',
        //             title: '又一新篇章——凡己科技正式进军观光车行业',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '12-13',
        //             year: '2018.12',
        //             redurl:'https://mp.weixin.qq.com/s/YZodoumO1FwBwStAD_WYrA'
        //         },{
        //             id: '014',
        //             title: '开拓市场 服务先行——凡己科技开展安徽合力江苏、广东、山东区域产品培训系列活动',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '12-06',
        //             year: '2018.12',
        //             redurl:'https://mp.weixin.qq.com/s/eZgCuKfRUBIZ6ZzOqfBY4g'
        //         },{
        //             id: '015',
        //             title: '凡己科技：秉持初心，快速发展',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '12-20',
        //             year: '2018.12',
        //             redurl:'https://mp.weixin.qq.com/s/n6RFVeRVpTPAIzHT_-ZGKQ'
        //         },{
        //             id: '016',
        //             title: '凡己科技智能化大仪表成为安徽合力叉车新标配',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '10-15',
        //             year: '2018.10',
        //             redurl:'https://mp.weixin.qq.com/s/m2zGBVKveiZ4DPXAPx3Zcg'
        //         },{
        //             id: '017',
        //             title: '凡己“芯”品，进一步俘获客户',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '07-31',
        //             year: '2018.07',
        //             redurl:''
        //         },{
        //             id: '018',
        //             title: '炎热将至，叉车也要防“中暑”',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '06-21',
        //             year: '2018.06',
        //             redurl:'https://mp.weixin.qq.com/s/effQkCly0n5l4vYNcROzGA'
        //         },{
        //             id: '019',
        //             title: '谈锂电怎么能少了它……',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '05-30',
        //             year: '2018.05',
        //             redurl:'https://mp.weixin.qq.com/s/wMadpYAAFUSIuS51Yzlq1g'
        //         },{
        //             id: '020',
        //             title: '中国智能物料搬运新能源的发展——事关你我他',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '05-13',
        //             year: '2018.05',
        //             redurl:'https://mp.weixin.qq.com/s/hpTo-9VxXDmGeddlV0QoVw'
        //         },{
        //             id: '021',
        //             title: '热烈庆祝凡己科技（苏州）有限公司当选中国工程机械工业协会工业车辆分会理事单位',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '02-22',
        //             year: '2018.02',
        //             redurl:''
        //         },{
        //             id: '022',
        //             title: '凡己电控那么抗造，你知道吗？ ——来自凡己电控用户使用5688小时后的反馈',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-04',
        //             year: '2018.01',
        //             redurl:''
        //         },{
        //             id: '023',
        //             title: '严谨铸就经典 品质岁月沉淀 ——来自凡己电控第一位用户4年半的使用反馈',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-28',
        //             year: '2017.11',
        //             redurl:''
        //         },{
        //             id: '024',
        //             title: '凡己科技与大型投资机构签署战略合作协议',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-09',
        //             year: '2017.11',
        //             redurl:''
        //         },{
        //             id: '025',
        //             title: '敢于担当凡己赢信赖 源于品质郑重许诺言',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-09',
        //             year: '2017.11',
        //             redurl:''
        //         },{
        //             id: '026',
        //             title: '【物流装备】严谨成就一贯品质 中国芯开创叉车新时代——凡己科技（苏州）专题',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '09-27',
        //             year: '2017.09',
        //             redurl:''
        //         },{
        //             id: '027',
        //             title: '习近平：强化“中国制造”与“瑞士工业4.0”对接',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '09-15',
        //             year: '2017.09',
        //             redurl:''
        //         },{
        //             id: '028',
        //             title: '创新力提升产业价值——凡己科控CeMAT ASIA2016展会推出二代新品',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '09-01',
        //             year: '2017.09',
        //             redurl:''
        //         },{
        //             id: '029',
        //             title: '杭叉搭载了凡己电控后第一台交付用户的叉车怎么样了？',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '06-09',
        //             year: '2017.06',
        //             redurl:''
        //         },{
        //             id: '030',
        //             title: 'FJ推出全新三合一仪表 翻开叉车服务行业新篇章',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '06-09',
        //             year: '2017.06',
        //             redurl:''
        //         },{
        //             id: '031',
        //             title: 'TEU新品推介会：电控，就选凡己科技！',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '05-25',
        //             year: '2017.05',
        //             redurl:''
        //         },{
        //             id: '032',
        //             title: '凡己电控搭载杭叉全系列产品，车辆远程监控数据传输系统也已上线',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '04-20',
        //             year: '2017.04',
        //             redurl:''
        //         },{
        //             id: '033',
        //             title: '凡己科技用芯为中联重科服务',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '04-10',
        //             year: '2017.04',
        //             redurl:''
        //         },{
        //             id: '034',
        //             title: '凡己科技&吉鑫祥 产品交流培训圆满落幕',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '03-10',
        //             year: '2017.03',
        //             redurl:''
        //         },{
        //             id: '035',
        //             title: '凡己科技：大步向前 不忘初心',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '02-18',
        //             year: '2017.02',
        //             redurl:''
        //         },{
        //             id: '036',
        //             title: '凡己科技：竭诚服务，我们一直是这么做的！',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-19',
        //             year: '2017.01',
        //             redurl:''
        //         },{
        //             id: '037',
        //             title: '2015亚洲物流展（CeMAT）北京凡己科控展示创新研发实力',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-13',
        //             year: '2017.01',
        //             redurl:''
        //         },{
        //             id: '038',
        //             title: '“凡己科控国内首家掌握电控核心技术”入选2014年中国工业车辆行业十大新闻',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '12-24',
        //             year: '2016.12',
        //             redurl:''
        //         },{
        //             id: '039',
        //             title: '北京凡己斩获“首届中国工业车辆创新奖”两项产品创新大奖',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-24',
        //             year: '2016.11',
        //             redurl:''
        //         },{
        //             id: '040',
        //             title: '“中国芯”凡己科技总部迁往苏州',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-15',
        //             year: '2015.11',
        //             redurl:''
        //         },{
        //             id: '041',
        //             title: '你以为凡己科技只是产品好吗？',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-15',
        //             year: '2015.11',
        //             redurl:''
        //         },{
        //             id: '042',
        //             title: 'FJ全新三合一仪表 推动叉车服务行业新征程',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '09-24',
        //             year: '2015.09',
        //             redurl:''
        //         },{
        //             id: '043',
        //             title: '控制器助力国产电动叉车新发展',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '01-15',
        //             year: '2015.01',
        //             redurl:''
        //         },{
        //             id: '044',
        //             title: '凡己科控惊艳亮相CeMAT Asia 2014 展览会',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '11-09',
        //             year: '2014.11',
        //             redurl:''
        //         },{
        //             id: '045',
        //             title: '透视凡己(FJ)电控的核心技术',
        //             // introduce: '凡己科技为杭叉集团定制了车辆远程监控数据传输系统，目前已完成调试。',
        //             date: '10-25',
        //             year: '2014.10',
        //             redurl:''
        //         }
            
        //     ]
    };
  },
  methods:{
    page(index) {
            this.$router.push({path:'/newsDetail', query: {index}});
        }
  },
  mounted() {
    /* banner-swiper */
    debugger
            let that=this;
            this.http.post("/api/FJ_News/GetAllNews?language=0",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.newsList=objResult.data;
                }
            });
  }
};
</script>
  
<style scoped lang="scss">
.header {
    background: url('../../assets/img/newsbanner.jpg') no-repeat;
    background-size: 100%;
}
.news-container{
    overflow: hidden;
    margin-bottom: 0;
    list-style: none;
}
.news-container>li{
    width: 55.5%;
    height: 120px;
    float: left;
    color: #333;
    text-align: right;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
}
.news-container>li:hover{
    color: #0a7846;
   font-weight: bold;
    border: 1px solid #ffffff;
    cursor: pointer;
}


.news-container>li:nth-of-type(2n){
    float: right;
    text-align: left;
}
.news-container>li>.content{
    width: 60%;
    float: left;
    padding: 10px 0;
    line-height: 30px;
}
.news-container>li>.time{
    width: 20%;
    float: left;
    padding: 10px 0;
}
.news-container>li>.time>p{
    font-size: 30px;
    margin: 5px 0;
}
.news-container>li>.circle{
    width: 20%;
    height: 100%;
    float: left;
    position: relative;
}
.news-container>li>.circle>img{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 20px;
    height: 20px;
    // background-color:#0a7846;
}
.news-container>li>.circle>i{
    display: block;
    width: 1px;
    height: 100%;
    background: #707070;
}
.news-container>li:nth-of-type(2n)>.content{
    float: right;
}
.news-container>li:nth-of-type(2n)>.time{
    float: right;
}
.news-container>li:nth-of-type(2n)>.circle{
    float: right;
}
.news-container>li>.circle>i{
    height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
}
.more{
    font-size: 25px;
    color: #707070;
}
.more>i{
    cursor: pointer;
}
@media screen and (max-width: 767px){
    .news-container>li{
        width: 100%;
    }
    .news-container>li>.content{
        width: 70%;
        text-align: left;
        float: right;
    }
    .news-container>li>.time{
        width: 30%;
        text-align: left;
        float: right;
    }
    .news-container>li>.circle{
        display: none;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/views/news/index.vue